import {
    useGetClientOrganizationsQuery,
    useGetClientPlansQuery,
} from '@/state/user/user-client';
import { useTenant } from './use-tenant';
import { skipToken } from '@reduxjs/toolkit/query';

export const useClientPermissions = () => {
    const { tenant } = useTenant();

    const { data: organizations, isLoading: loadingOrgs } =
        useGetClientOrganizationsQuery();
    const { data: plans, isLoading: loadingPlans } = useGetClientPlansQuery(
        tenant ? { tenant } : skipToken
    );

    // Find the current organization based on tenant
    const currentOrg = organizations?.find(
        (org) => org?.client?.schema_name === tenant
    );
    const publicSuperAdminOrg = organizations?.find(
        (org) =>
            org?.client?.schema_name === 'public' &&
            org?.user_roles?.includes('SUPER ADMIN')
    );

    const userRoles = currentOrg?.user_roles || [];
    const isSuperAdmin = Boolean(publicSuperAdminOrg);
    const isSchoolAdmin = userRoles.includes('SCHOOL ADMIN');
    const isTeacher = userRoles.includes('TEACHER');
    const isStudent = userRoles.includes('STUDENT');

    // Helper to check for module code
    const checkModule = (code: string) => {
        return plans?.some((planObj) => {
            return planObj?.plan?.plan_modules_cost?.some(
                (module) => module.module_code === code
            );
        });
    };

    

    const hasAIModule = Boolean(checkModule('AI'));
    const hasLMSModule = Boolean(checkModule('LMS'));
    const hasProjectModule = Boolean(checkModule('Project'));
    const hasSyncModule = Boolean(checkModule('Sync'));
    const organizationType = currentOrg?.client?.organization_type;
    const isCompany = organizationType  === 'Company/Business/Enterprise'  || organizationType === 'NGO/INGO' || organizationType === 'City/Municipality';

    return {
        isSuperAdmin,
        isSchoolAdmin,
        isTeacher,
        isStudent,
        isCompany,
        hasAIModule,
        hasLMSModule,
        hasProjectModule,
        hasSyncModule,
        isLoading: loadingOrgs || loadingPlans,
        userRoles,
        currentOrg,
        currentOrgId: currentOrg?.client?.id,
    };
};
